// models
import type { ReqGetUserDetail } from 'modules/user';
import type {
  ReqWorkerList,
  ReqWorkerSafetyHistory,
  ReqWorkersNotInSafetyTraining
} from '../model/worker.model';

/**
 * Worker 관련 Query Keys
 *
 * @description
 * 근로자 관련 query-key들을 관리합니다.
 */
export const workerKeys = {
  /** ALL */
  WORKER_ALL: ['worker'],

  /** 근로자 페이지 조회 */
  GET_WORKER_LIST: (query: ReqWorkerList) => ['worker', 'getWorkerList', JSON.stringify(query)],

  /** 근로자 상세 조회 */
  GET_WORKER_DETAIL: (data: ReqGetUserDetail) => [
    'worker',
    'getWorkerDetail',
    JSON.stringify(data)
  ],

  /** 근로자 안전교육 이력 조회 */
  GET_WORKER_SAFETY_HISTORY: (data: ReqWorkerSafetyHistory) => [
    'worker',
    'getWorkerSafetyHistory',
    JSON.stringify(data)
  ],

  /** 근로자/관리자 목록 전체 조회 */
  GET_WORKER_AND_ADMIN_LIST: (query: ReqWorkerList) => [
    'worker',
    'getWorkerAndAdminList',
    JSON.stringify(query)
  ],

  /** 안전교육에 참여하지 않은 사용자 목록 조회 */
  GET_WORKERS_NOT_IN_SAFETY_TRAINING: (query: ReqWorkersNotInSafetyTraining) => [
    'worker',
    'getWorkersNotInSafetyTraining',
    JSON.stringify(query)
  ]
};
